<template>
  <BasePanelWithHeader headerText="Funding Source Types">
    <BaseSimpleDataTable
      :headers="filteredHeaders"
      :items="filteredLuFundingSourceTypes"
      :loading="loading"
      search
    >
      <template v-slot:prependParams>
        <v-switch
          v-model="showInactive"
          label="Show Inactive"
          class="py-4"
        ></v-switch>
      </template>
      <template v-slot:appendParams>
        <BaseTooltipButton
          small
          @click="$refs.luFundingSourceTypeForm.addLuFundingSourceType()"
          icon="mdi-plus"
          iconColor="white"
          buttonClass="primary mt-8 ml-2"
          >Add Funding Source Type
        </BaseTooltipButton>
      </template>
      <template v-slot:item.edit="{ item }">
        <BaseTooltipButton
          small
          @click="$refs.luFundingSourceTypeForm.editLuFundingSourceType(item)"
          iconColor="primary"
          icon="mdi-pencil"
          >Edit Funding Source Type
        </BaseTooltipButton>
      </template>
      <template v-slot:item.IsActive="{ item }">
        {{ item.IsActive ? 'Yes' : 'No' }}
      </template>
      <template v-slot:item.delete="{ item }">
        <BaseTooltipButton
          small
          @click="$refs.luFundingSourceTypeDelete.deleteConfirm(item)"
          iconColor="primary"
          icon="mdi-delete"
          >Delete Funding Source Type
        </BaseTooltipButton>
      </template>
    </BaseSimpleDataTable>
    <BaseDeleteConfirm
      ref="luFundingSourceTypeDelete"
      :delete="deleteLuFundingSourceType"
      @refresh="clearLookupCacheAndReloadLuFundingSourceTypes"
    >
      Are you sure you want to delete this funding source type?
    </BaseDeleteConfirm>
    <LuFundingSourceTypeDialogForm
      ref="luFundingSourceTypeForm"
      @refresh="clearLookupCacheAndReloadLuFundingSourceTypes"
    >
    </LuFundingSourceTypeDialogForm>
  </BasePanelWithHeader>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import LuFundingSourceTypeDialogForm from '@components/form/add-edit/LuFundingSourceTypeDialog'
export default {
  components: {
    LuFundingSourceTypeDialogForm,
  },
  data: () => ({
    showInactive: false,
  }),
  created() {
    this.loadLuFundingSourceTypes()
  },
  computed: {
    ...get('luFundingSourceType', ['luFundingSourceTypes', 'loading']),
    filteredLuFundingSourceTypes() {
      var list = this.luFundingSourceTypes.filter((i) => true)
      if (!this.showInactive) {
        list = list.filter((i) => i.IsActive)
      }
      return list
    },
    headers() {
      return [
        {
          text: '',
          align: 'left',
          value: 'edit',
          visible: true,
          sortable: false,
        },
        {
          text: 'Id',
          align: 'center',
          sortable: true,
          value: 'Id',
          visible: false,
        },
        {
          text: 'Description',
          align: 'left',
          sortable: true,
          value: 'Description',
          visible: true,
        },
        {
          text: 'Is Active',
          align: 'left',
          sortable: true,
          value: 'IsActive',
          visible: this.showInactive,
        },
        {
          text: '',
          align: 'center',
          value: 'delete',
          visible: false,
          sortable: false,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter((h) => h.visible)
    },
  },
  methods: {
    ...call('luFundingSourceType', [
      'deleteLuFundingSourceType',
      'loadLuFundingSourceTypes',
      'clearLookupCacheAndReloadLuFundingSourceTypes',
    ]),
  },
}
</script>
<style></style>
